'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _dec4, _dec5, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactCookie = require('react-cookie');

var _reactCookie2 = _interopRequireDefault(_reactCookie);

var _reactRedux = require('react-redux');

var _chemist = require('chemist');

var _formSerialize = require('form-serialize');

var _formSerialize2 = _interopRequireDefault(_formSerialize);

var _prefetch = require('chemist/dist/helpers/prefetch');

var _prefetch2 = _interopRequireDefault(_prefetch);

var _reactI18next = require('react-i18next');

var _order = require('../../actions/order');

var _order2 = require('../../helpers/order');

var _redirectable = require('../../helpers/redirectable');

var _redirectable2 = _interopRequireDefault(_redirectable);

var _cart = require('../../actions/cart');

var _loading = require('../../actions/loading');

var _quickOrder = require('../../actions/quickOrder');

var _CartForm = require('../../components/CartForm');

var _CartForm2 = _interopRequireDefault(_CartForm);

var _CheckoutBanner = require('../../components/CheckoutBanner');

var _CheckoutBanner2 = _interopRequireDefault(_CheckoutBanner);

var _ErrorMessage = require('../../components/ErrorMessage');

var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);

var _MessageWithAction = require('../../components/MessageWithAction');

var _MessageWithAction2 = _interopRequireDefault(_MessageWithAction);

var _painters = require('../../components/EmptyCart/painters');

var _painters2 = _interopRequireDefault(_painters);

var _localisedPaths = require('../../helpers/localisedPaths');

var _resetCookies = require('../../helpers/resetCookies');

var _resetCookies2 = _interopRequireDefault(_resetCookies);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OrderEditPage = (_dec = (0, _prefetch2.default)(function (_ref) {
  var store = _ref.store;

  if (_reactCookie2.default.load('hasOrder')) {
    return store.dispatch((0, _order.orderFetch)('cart')).then(function () {
      return store.dispatch((0, _order.orderDeliveryEstimate)());
    });
  }

  return store.dispatch((0, _order.orderFetch)('cart'));
}), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    order: state.order,
    error: state.error,
    cart: state.cart,
    user: state.user,
    quickOrder: state.quickOrder
  };
}), _dec3 = (0, _chemist.configurable)(), _dec4 = (0, _reactI18next.translate)(), _dec5 = (0, _redirectable2.default)(), _dec(_class = _dec2(_class = _dec3(_class = _dec4(_class = _dec5(_class = function (_React$Component) {
  (0, _inherits3.default)(OrderEditPage, _React$Component);

  function OrderEditPage(props) {
    (0, _classCallCheck3.default)(this, OrderEditPage);

    // check for lineItemErrors
    var _this = (0, _possibleConstructorReturn3.default)(this, (OrderEditPage.__proto__ || (0, _getPrototypeOf2.default)(OrderEditPage)).call(this, props));

    var error = props.order && props.order.error;
    var message = error && error.message;
    var lineItemId = message && message.lineItemId;

    _this.state = {
      lineItemErrors: lineItemId ? (0, _defineProperty3.default)({}, lineItemId, message.message) : {}
    };
    return _this;
  }

  (0, _createClass3.default)(OrderEditPage, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.order.state === 'complete') {
        (0, _resetCookies2.default)();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.props.dispatch((0, _loading.clearLoading)());
    }
  }, {
    key: 'updateForm',
    value: function updateForm(event) {
      var _this2 = this;

      if (event.preventDefault) {
        event.preventDefault();
      }
      var data = (0, _formSerialize2.default)((0, _reactDom.findDOMNode)(this.form), { hash: true });

      if (event.currentTarget && event.currentTarget.value === '+more') {
        this.props.dispatch((0, _cart.setLineItemInput)(data));
        return this.props.dispatch((0, _order.orderDeliveryEstimate)());
      }

      this.props.dispatch((0, _loading.setLoading)());
      return this.props.dispatch((0, _order.orderUpdate)(data)).then(function () {
        var error = _this2.props.order && _this2.props.order.error;
        var message = error && error.message;
        var lineItemId = message && message.lineItemId;

        _this2.setState({
          lineItemErrors: lineItemId ? (0, _defineProperty3.default)({}, lineItemId, message.message) : {}
        });
      }).then(function () {
        return _this2.props.dispatch((0, _order.orderFetch)('cart'));
      }).then(function () {
        return _this2.props.dispatch((0, _order.orderDeliveryEstimate)());
      });
    }
  }, {
    key: 'removeLineItem',
    value: function removeLineItem(event) {
      event.preventDefault();
      var lineItemId = event.currentTarget.getAttribute('data-lineitem');
      this.props.dispatch((0, _loading.setLoading)());
      this.props.dispatch((0, _order.lineItemRemove)(lineItemId));
    }
  }, {
    key: 'switchAllChips',
    value: function switchAllChips(items, oldIds) {
      var _this3 = this;

      this.props.dispatch((0, _loading.setLoading)());
      this.props.dispatch((0, _cart.addManyToCart)(items, oldIds, 'We\'re sorry, not all colour chip testers could be switched.')).then(function () {
        return _this3.props.localisedRedirect('/cart');
      });
    }
  }, {
    key: 'switchChipSize',
    value: function switchChipSize(event, newSize, lineItem) {
      var _this4 = this;

      event.preventDefault();
      this.props.dispatch((0, _loading.setLoading)());

      var id = lineItem.id;
      var quantity = lineItem.quantity;
      var articleNumber = lineItem.variant.sku.split(':')[1].split('_')[0];
      articleNumber = '' + articleNumber + (newSize === 'A5' ? '_A5' : '');

      this.props.dispatch((0, _cart.addChipToCart)({
        articleNumber: articleNumber,
        quantity: quantity
      }, id, this.props.order)).then(function () {
        _this4.props.localisedRedirect('/cart');
      });
    }
  }, {
    key: 'requestFilteredProducts',
    value: function requestFilteredProducts(articleNumberPartial) {
      var _this5 = this;

      this.props.dispatch((0, _quickOrder.getFilteredProducts)(articleNumberPartial)).then(function () {
        return _this5.setState({
          filteredProducts: _this5.props.quickOrder
        });
      });
    }
  }, {
    key: 'addDryTester',
    value: function addDryTester(articleNumber) {
      var _this6 = this;

      this.props.dispatch((0, _loading.setLoading)());
      this.props.dispatch((0, _cart.addToCart)({ articleNumber: articleNumber, quantity: 1 }, this.props.order)).then(function () {
        return _this6.props.localisedRedirect('/cart');
      });
    }
  }, {
    key: 'handleTransitionToNextStep',
    value: function handleTransitionToNextStep(event) {
      event.preventDefault();
      this.props.dispatch((0, _loading.setLoading)());

      var hasRegistration = this.props.config.store.hasRegistration;


      if (hasRegistration && !_reactCookie2.default.load('sessionToken')) {
        this.props.localisedRedirect('/checkout/registration');
      } else {
        this.props.localisedRedirect('/checkout/address');
      }
    }
  }, {
    key: 'renderCart',
    value: function renderCart() {
      var _this7 = this;

      var t = this.props.t;

      var hasLineItems = (0, _order2.orderHasLineItems)(this.props.order);
      var shouldDisplayCartForm = hasLineItems && this.props.order.state !== 'complete';
      var lng = this.props.params.lng;

      if (shouldDisplayCartForm) {
        return _react2.default.createElement(_CartForm2.default, {
          order: this.props.order,
          user: this.props.user,
          onSubmit: this.handleTransitionToNextStep.bind(this),
          onChange: this.updateForm.bind(this),
          switchChipSize: this.switchChipSize.bind(this),
          switchAllChips: this.switchAllChips.bind(this),
          requestFilteredProducts: this.requestFilteredProducts.bind(this),
          addDryTester: this.addDryTester.bind(this),
          onRemove: this.removeLineItem.bind(this),
          cart: this.props.cart,
          params: this.props.params,
          filteredProducts: this.props.quickOrder,
          lineItemErrors: this.state.lineItemErrors,
          ref: function ref(el) {
            return _this7.form = el;
          }
        });
      }

      if (this.props.config.theme === 'painters') {
        return _react2.default.createElement(_painters2.default, this.props);
      }

      return _react2.default.createElement(_MessageWithAction2.default, {
        url: (0, _localisedPaths.localisedPath)(this.props.config.store, 'productsPath', lng),
        message: t('spree.your_cart_is_empty'),
        actionLabel: t('spree.continue_shopping')
      });
    }
  }, {
    key: 'renderError',
    value: function renderError(error) {
      var message = Array.isArray(error.messages) ? error.messages[0] : error.message;

      // dont render the error message banner when there is a line item stock error
      if (message.lineItemId) return null;

      return _react2.default.createElement(_ErrorMessage2.default, { message: message });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          config = _props.config;

      var cartStyle = (0, _order2.orderHasLineItems)(this.props.order) ? '' : 'empty-cart';
      var theme = config.theme;

      var cartTitle = theme === 'woodcare' ? t('woodcare.shopping_cart') : t('spree.shopping_cart');

      return _react2.default.createElement(
        'div',
        { className: 'container-page-' + cartStyle },
        this.props.order.error ? this.renderError(this.props.order.error) : '',
        this.props.cart.error ? this.renderError(this.props.cart.error) : null,
        _react2.default.createElement(_CheckoutBanner2.default, { title: cartTitle, cartStyle: cartStyle }),
        _react2.default.createElement(
          'div',
          { className: 'container container-page container-page-cart' },
          _react2.default.createElement(_reactHelmet2.default, { title: t('spree.cart') }),
          this.renderCart()
        )
      );
    }
  }]);
  return OrderEditPage;
}(_react2.default.Component)) || _class) || _class) || _class) || _class) || _class);
exports.default = OrderEditPage;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/containers/OrderEditPage/index.js
// module id = 2511
// module chunks = 0